<div [ngClass]="responsiveService.getBigSmall()">
    <ess-dialog-title></ess-dialog-title>
    <mat-dialog-content class="dialog-content">
        <div class="iframe-container">
            <iframe src='../../assets/terms/terms-en.html' class="iframe"></iframe>
        </div>
    </mat-dialog-content>
    <div class="new-window-container"><a (click)="openNewWindow()">Open in new window for printing</a></div>